import { useAuth } from '@/contexts/AuthContext'
import { Button } from '@/components/ui/button'
import { LogOut, Clock } from 'lucide-react'

export default function PendingApproval() {
  const { logout } = useAuth()

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background p-6">
      <div className="max-w-md w-full text-center space-y-6">
        <div className="flex justify-center">
          <div className="rounded-full bg-amber-500/20 p-4">
            <Clock className="h-12 w-12 text-amber-500" />
          </div>
        </div>
        <div>
          <h1 className="text-2xl font-bold text-foreground">Account Pending Approval</h1>
          <p className="mt-2 text-muted-foreground">
            Your account has been registered successfully. An administrator will review and approve your account before you can access the platform.
          </p>
        </div>
        <div className="rounded-lg bg-muted/50 p-4 text-sm text-muted-foreground">
          <p>You will receive an email once your account has been approved. You can also ask an administrator to approve your account from the admin panel.</p>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button variant="outline" onClick={logout} className="gap-2">
            <LogOut className="h-4 w-4" />
            Sign Out
          </Button>
        </div>
      </div>
    </div>
  )
}
